<script setup lang="ts">
import { FormRow } from '@shared/ui/form-row'
import { RadioItem } from '@shared/ui/radio'

import { useTutorApplicationStore } from '../../model/store'
import { useOnboardingTimeframe } from '../../model/additional-questions/onboarding-timeframe.hooks'
import { onboardingTimeframe } from '../../config/additional-questions'

defineOptions({
  name: 'OnboardingTimeframe',
})

const tutorApplicationStore = useTutorApplicationStore()

const {
  mode,
  label,
  setOnboardingTimeframe,
} = useOnboardingTimeframe()

</script>

<template>
  <FormRow
    :label="label"
    required
  >
    <RadioItem
      v-for="option in onboardingTimeframe"
      :key="option.value"
      :mode="mode"
      :checked="tutorApplicationStore.form.onboardingTimeframe === option.value"
      :label="option.label"
      @click="setOnboardingTimeframe(option.value)"
    />
  </FormRow>
</template>
